import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionService } from '@core/services/session.service';
import { StorageKey } from '@core/config/global.config';

export type MenuPosition = 'top' | 'left';

/**
 * Persisted "where does the main navigation live" preference — mirrors the
 * density/theme pattern (SessionService + BehaviorSubject), but unlike those there's no
 * CSS variable to push: LayoutComponent subscribes directly and swaps between the top
 * navbar and the left sidebar template.
 */
@Injectable({
  providedIn: 'root',
})
export class MenuPositionService {
  private sessionService = inject(SessionService);

  private menuPosition$: BehaviorSubject<MenuPosition>;

  constructor() {
    const initial = this.readStoredMenuPosition();
    this.menuPosition$ = new BehaviorSubject<MenuPosition>(initial);
  }

  getMenuPosition(): Observable<MenuPosition> {
    return this.menuPosition$.asObservable();
  }

  setMenuPosition(menuPosition: MenuPosition): void {
    this.sessionService.setItem(StorageKey.menuPosition, menuPosition);
    this.menuPosition$.next(menuPosition);
  }

  private readStoredMenuPosition(): MenuPosition {
    const stored = this.sessionService.getItem(StorageKey.menuPosition);
    return stored === 'top' || stored === 'left' ? stored : 'top';
  }
}
